/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface GetMealResponseDataDDAppliedMealListInner {
  /**
   * 機内食種別<br/> special：特別機内食<br/> chargeable：有料機内食<br/> preorder：事前オーダーミール<br/> notMeal：辞退
   */
  type?: GetMealResponseDataDDAppliedMealListInner.TypeEnum;
  /**
   * SSRコード
   */
  code?: string;
  /**
   * ASWDB(マスタ)から取得した事前オーダーミールメッセージID
   */
  key?: string;
  /**
   * ステータス
   */
  status?: string;
  /**
   * 関連EMD有無<br/> 当該セグメントおよび搭乗者に関連する、申込済機内食のEMDが存在する場合にtrue<br/> ※リクエストパラメータ内にcartIdが存在する場合、false固定とする
   */
  isExistRelatedEmd?: boolean;
  /**
   * 関連TSM有無<br/> 当該セグメントおよび搭乗者に関連する、申込済機内食のTSMが存在する場合にtrue<br/> ※リクエストパラメータ内にcartIdが存在する場合、false固定とする
   */
  isExistRelatedTsm?: boolean;
}
export namespace GetMealResponseDataDDAppliedMealListInner {
  export type TypeEnum = 'special' | 'chargeable' | 'preorder' | 'notMeal';
  export const TypeEnum = {
    Special: 'special' as TypeEnum,
    Chargeable: 'chargeable' as TypeEnum,
    Preorder: 'preorder' as TypeEnum,
    NotMeal: 'notMeal' as TypeEnum,
  };
}
